<div class="service-item">
  <img class="service-item__img" [src]="'assets/images/service-block/' + service.src | bmAssetUrl" alt="service cover" />
  <div class="service-item__left">
    <div>
      <h4 class="service-item__title">{{ service.title }}</h4>
      <p class="service-item__price-mob">{{ service.price }} {{ currencySign }}</p>
      <p class="service-item__descr">{{ service.description }}</p>
    </div>
    <div class="service-item__details">
      <div class="service-item__btn-container">
        <bmcore-button
          title="{{ lg.button.moreDetails }}"
          routerPath="/services/{{ service.id }}"
          icon="btv-icon-btn-details"
        >
        </bmcore-button>
      </div>
      <p class="service-item__price">{{ service.price }} {{ currencySign }}</p>
    </div>
  </div>
</div>
